
<template>
  <div>
    <div class="lptActionsHeader">Step settings</div>
      <el-row>
        <div class=""> 
          <div v-sticky sticky-offset="top" sticky-side="top" class="lptActionWrapper">
              <component :model="getEntity()" :key="this.editedId" :editedId="this.editedId" v-bind:is="getType()"></component>
          </div>
        </div>
      </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Empty from './scenario/Empty';
import Open from './scenario/Open';
import Yandex from './scenario/Yandex';
import Google from './scenario/Google';
import Unsupported from './scenario/Unsupported';
import Click from './scenario/Click';
import Wait from './scenario/Wait';
import ReadPage from './scenario/ReadPage';
import Hover from './scenario/Hover';
import InsertMulti from './scenario/InsertMulti';
import ElementPresence from './scenario/ElementPresence';
import SendContent from './scenario/SendContent';
import EndOfTask from './scenario/EndOfTask';
import SuccessState from './scenario/SuccessState';
import SetCookie from './scenario/SetCookie';
import SavePageAsPdf from './scenario/SavePageAsPdf';
import SetUrlBlocklist from './scenario/SetUrlBlocklist';
import DonorAcceptor from './scenario/DonorAcceptor';
import AvitoRegistration from './scenario/AvitoRegistration';
import YandexImageSearch from './scenario/YandexImageSearch';


import BotsService from '../../services/bots.service';

export default {
  name: 'Settings',
  data () {
    return {
      editedId: 0,
      actions: [
          {
                type: 'yandex',
                name: 'Search in Yandex'
          },
          {
                type: 'google',
                name: 'Search in Google'
          },
          {
                type: 'open',
                name: 'Open site'
          }
      ],
    }
  },

  methods: {
    getEntity() {
      if (!this.editedId) {
        return {
          name:'nothing to edit'
        }
      }
      return this.$store.state.bot.bot.data.scenario.filter(element => element.id === this.editedId)[0];
    },
    getType() {
      //check state for edited id
      if (this.editedId == 0) {
        return 'Empty';
      }
      
      var entity = this.getEntity();
      
      switch (entity.name) {
        case 'yandex_search': return 'Yandex';
        case 'google_search': return 'Google';
        case 'click': return 'Click';
        case 'open': return 'Open';
        case 'wait': return 'Wait';
        case 'read_page': return 'ReadPage';
        case 'hover': return 'Hover';
        case 'insert_multi': return 'InsertMulti';
        case 'send_content': return 'SendContent';
        case 'element_presence': return 'ElementPresence';
        case 'end_of_task': return 'EndOfTask';
        case 'success_state': return 'SuccessState';
        case 'set_cookie': return 'SetCookie';
        case 'save_page_as_pdf': return 'SavePageAsPdf';
        case 'set_url_blocklist': return 'SetUrlBlocklist';
        case 'donor_acceptor': return 'DonorAcceptor';
        case 'avito_registration': return 'AvitoRegistration';
        case 'yandex_image_search': return 'YandexImageSearch';
        default: return 'Unsupported';
      }
    }
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
      idToEdit: 'idToEdit',
    }),
     ...mapGetters('bot', [
    'idEdited'
    ]),
   
  },
  components: {
    Empty,
    Open,
    Yandex,
    Click,
    Unsupported,
    Wait,
    Google,
    ReadPage,
    Hover,
    InsertMulti,
    ElementPresence,
    SendContent,
    SetCookie,
    EndOfTask,
    SuccessState,
    SavePageAsPdf,
    SetUrlBlocklist,
    DonorAcceptor,
    AvitoRegistration,
    YandexImageSearch,
  },
  mounted: function () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'bot/SET_EDITED_ID') {
          this.editedId = mutation.payload;
        }
    })
  },
}
</script>

<style lang="scss" scoped>
.lptActionWrapper{
    
}
.lptActionListItem:nth-child(odd){
  background-color: #dee1ec;
}
.addButton {
  
  width: 25px;
}
.actionAdd{
  
}
.lptActionsHeader {
    background-color: #b5bad0;
    color:white;
    font-weight: 400;
    font-size: 25px;
    height:50px;
    padding: 15px;
}
.addButtonWrapper{
  height: 60px;
}
.lptActionListItem{
    color: #555;
    height: 60px;
    padding: 20px;
}
.lpt-login-wrapper {
  height: 100px;
}

.loginBtn{
  width:100%;
}
.login-group-element {
  margin-bottom: 5px;
}
.fixoSettings{
    position:fixed;
    overflow:hidden;
    
}
.login {
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;

  .main {
    padding: 30px 15px;
    background: #fff;
    width: 400px;
    
    .header {
      text-align: center;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
    }

    .error {
      background-color: red;
      padding: 10px;
      font-size: 12px;
      opacity: 1;
      transition: all 0.5s;
    }
  }
}
</style>
